import { render } from "./ZfAvatar.vue?vue&type=template&id=8ed187a6&scoped=true&ts=true"
import script from "./ZfAvatar.vue?vue&type=script&lang=ts"
export * from "./ZfAvatar.vue?vue&type=script&lang=ts"

import "./ZfAvatar.vue?vue&type=style&index=0&id=8ed187a6&lang=less&scoped=true"
import "./ZfAvatar.vue?vue&type=style&index=1&id=8ed187a6&lang=less"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.30_vue@3.2.37_webpack@5.105.4_@swc+core@1.15.18_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ed187a6"]])

export default __exports__